export const permissionsSliceName = "permissions"
